module.exports = __webpack_public_path__ + "static/media/menu.2810167c.png";